import { render } from "./Transformation_seeting.vue?vue&type=template&id=25ffc6cb&scoped=true"
import script from "./Transformation_seeting.vue?vue&type=script&lang=js"
export * from "./Transformation_seeting.vue?vue&type=script&lang=js"

import "./Transformation_seeting.vue?vue&type=style&index=0&id=25ffc6cb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ffc6cb"]])

export default __exports__